import { createSelector } from 'reselect';

const storeSelector = store => store;

export const userDetailsSelector = createSelector(storeSelector, ({ userInfo }) => {
  return userInfo;
});

export const journeyDetailsSelector = createSelector(storeSelector, ({ journeyDetails }) => {
  return journeyDetails;
});

export const nudgeSelector = createSelector(storeSelector, ({ nudge }) => {
  return nudge;
});

export const registerTeamResponseSelector = createSelector(
  userDetailsSelector,
  ({ registerTeam }) => {
    return registerTeam;
  },
);

export const journeyDetailsCampaignsSelector = createSelector(
  journeyDetailsSelector,
  ({ campaigns }) => {
    return campaigns;
  },
);

export const segmentListSelector = createSelector(nudgeSelector, ({ segmentList }) => {
  return segmentList;
});

export const templateListSelector = createSelector(nudgeSelector, ({ messageTemplateList }) => {
  return messageTemplateList;
});

export const selectCampaignsById = campaignId =>
  createSelector(journeyDetailsCampaignsSelector, campaigns =>
    campaigns.filter(cmp => cmp.campaignId === campaignId),
  );

export const multiCampaignNameSelector = createSelector(
  journeyDetailsSelector,
  ({ journeyName }) => {
    return journeyName;
  },
);

export const multiCampaignDescriptionSelector = createSelector(
  journeyDetailsSelector,
  ({ journeyDescription }) => {
    return journeyDescription;
  },
);

export const multiCampaignFormSubmissionSelector = createSelector(
  journeyDetailsSelector,
  ({ isFormSubmitted }) => {
    return isFormSubmitted;
  },
);

export const multiCampaignFormViewSelector = createSelector(
  journeyDetailsSelector,
  ({ readonly }) => {
    return readonly;
  },
);

export const multiCampaignResponseSelector = createSelector(
  journeyDetailsSelector,
  ({ response }) => {
    return response;
  },
);

export const notificationSelector = createSelector(storeSelector, ({ notifications }) => {
  return notifications;
});

export const campaignListSelector = createSelector(storeSelector, ({ campaign }) => {
  return campaign.createdCampaigns;
});

export const messageTemplateListSelector = createSelector(
  nudgeSelector,
  ({ messageTemplateList }) => {
    return messageTemplateList;
  },
);

export const messageTemplateDetailsListSelector = createSelector(
  nudgeSelector,
  ({ messageTemplateDetailList }) => {
    return messageTemplateDetailList;
  },
);

export const ruleFiltersSelector = createSelector(storeSelector, ({ ruleFilters }) => {
  return ruleFilters;
});

export const activeRuleFiltersSelector = createSelector(
  ruleFiltersSelector,
  ({ activeFilters }) => {
    return activeFilters;
  },
);

export const ruleFilterLeaderLevelSelector = createSelector(
  ruleFiltersSelector,
  ({ leaderJobLevel }) => {
    return leaderJobLevel;
  },
);

export const ruleFilterLeaderLevelLogin = createSelector(
  ruleFiltersSelector,
  ({ leaderLogins }) => {
    return leaderLogins;
  },
);

export const ruleFilterCountriesSelector = createSelector(ruleFiltersSelector, ({ countries }) => {
  return countries;
});

export const ruleFilterManagerStatusSelector = createSelector(
  ruleFiltersSelector,
  ({ isManager }) => {
    return isManager;
  },
);

export const ruleFilterEmployeeJobLevelSelector = createSelector(
  ruleFiltersSelector,
  ({ employeeJobLevels }) => {
    return employeeJobLevels;
  },
);

export const ruleFilterDateOperatorSelector = createSelector(
  ruleFiltersSelector,
  ({ dateOperator }) => {
    return dateOperator;
  },
);

export const ruleFilterHireStartSelector = createSelector(
  ruleFiltersSelector,
  ({ lastHireDateInMillis }) => {
    return lastHireDateInMillis;
  },
);

export const ruleFilterHireEndDateSelector = createSelector(
  ruleFiltersSelector,
  ({ lastHireEndDateInMillis }) => {
    return lastHireEndDateInMillis;
  },
);

export const ruleFilterMetricValueSelector = createSelector(
  ruleFiltersSelector,
  ({ metricValue }) => {
    return metricValue;
  },
);

export const ruleFilterMetricOperatorSelector = createSelector(
  ruleFiltersSelector,
  ({ metricOperator }) => {
    return metricOperator;
  },
);

export const ruleFilterMetricNameSelector = createSelector(
  ruleFiltersSelector,
  ({ metricName }) => {
    return metricName;
  },
);

export const initialDataSelector = createSelector(storeSelector, ({ initializeData }) => {
  return initializeData;
});

export const createContentSelector = createSelector(storeSelector, ({ createContent }) => {
  return createContent;
});

export const templateContentSelector = createSelector(
  createContentSelector,
  ({ contentElements }) => {
    return contentElements;
  },
);

export const createSegmentSelector = createSelector(storeSelector, ({ createSegment }) => {
  return createSegment;
});

export const currentSegmentDataSelector = createSelector(
  createSegmentSelector,
  ({ segmentData }) => {
    return segmentData;
  },
);
